"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const StartTime_1 = __importDefault(require("./StartTime"));
const axios_1 = __importDefault(require("axios"));
const WidgetButton_1 = __importDefault(require("./formControls/WidgetButton"));
function duration(props) {
    const [selectedDuration, setSelectedDuration] = (0, react_1.useState)(null);
    const [durationData, setDurationData] = (0, react_1.useState)(null);
    const [firstRender, setFirstRender] = (0, react_1.useState)(true);
    const handleDurationChange = (duration) => {
        console.log(duration);
        console.log("setting selected duration");
        setSelectedDuration(duration);
    };
    (0, react_1.useEffect)(() => {
        getDurationData();
    }, [props]);
    const getDurationData = () => {
        console.log("date", props.selectedDate);
        const baseUrl = "/api/widget/duration/" + props.uuid;
        const params = new URLSearchParams();
        params.append("selectedDate", props.selectedDate.toString());
        params.append("paxCount", props.paxCount.toString());
        axios_1.default
            .get(baseUrl, {
            params: params,
        })
            .then((response) => {
            console.log(response.data);
            setDurationData(response.data);
            if (firstRender) {
                setTimeout(() => {
                    var _a;
                    (_a = document.getElementById(props.parentElementId)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
                    setFirstRender(false);
                });
            }
        })
            .catch((error) => {
            console.log(error);
        });
    };
    return (react_1.default.createElement("div", { id: "duration" },
        durationData && durationData.durations.length == 0 && (react_1.default.createElement(material_1.Grid, { container: true },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.Typography, { variant: "h4" }, "Event Duration")),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.Typography, { variant: "body1" }, "No availablility for the selected date and passenger combination. Please try other options.")))),
        durationData && durationData.durations.length > 0 && (react_1.default.createElement(material_1.Grid, { container: true, spacing: 4 },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(material_1.Typography, { variant: "h4" }, "Event Duration")),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(material_1.Grid, { container: true }, durationData === null || durationData === void 0 ? void 0 : durationData.durations.map((duration) => (react_1.default.createElement(material_1.Grid, { item: true, xs: 3, key: duration.toString() },
                        react_1.default.createElement(WidgetButton_1.default, { key: duration.toString(), onClick: () => handleDurationChange(duration), selected: duration === selectedDuration },
                            react_1.default.createElement(material_1.Stack, null,
                                react_1.default.createElement(material_1.Typography, { variant: "body1" },
                                    react_1.default.createElement("strong", null, duration.toString())),
                                react_1.default.createElement(material_1.Typography, { variant: "body2" }, "hours"))))))))),
            selectedDuration && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(StartTime_1.default, { uuid: props.uuid, brandId: props.brandId, selectedDate: props.selectedDate, paxCount: props.paxCount, duration: selectedDuration, parentElementId: "duration" })))))));
}
exports.default = duration;
